import { CommonModule } from '@angular/common';
import { CheckboxComponent } from '../checkbox/checkbox.component';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  ViewEncapsulation,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { faStar } from '@fortawesome/duotone-regular-svg-icons';
import { FaIconComponent } from '../../atoms';

@Component({
  selector: 'orbit-form-extended-checkbox',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, CheckboxComponent, FaIconComponent],
  templateUrl: './form-extended-checkbox.component.html',
  styleUrl: './form-extended-checkbox.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Default,
})
export class FormExtendedCheckboxComponent {
  type = input<'checkbox' | 'radio'>('checkbox');
  item = input<string>();
  subtitle = input<string | null | undefined>();
  description = input<string | null>();
  name = input<string>();
  value = input<string>();
  defaultCtrl = new FormControl<string | null>(null);
  controller = input<FormControl>(this.defaultCtrl);

  showFavorite = input<boolean>(false);
  favorite = input<boolean>(false);
  titleForFavorite = input<string>('');
  titleForUnFavorite = input<string>('');

  favoriteChange = output<string | undefined>();

  star = faStar;

  isActive(): boolean {
    return this.type() === 'radio'
      ? this.controller().value === this.value()
      : !!this.controller().value;
  }

  isFavorite(): boolean {
    return this.favorite();
  }

  onFavoriteClick(evt: MouseEvent): void {
    /* avoid checking/unchecking the radio when the star is hit */
    evt.stopPropagation();
    this.favoriteChange.emit(this.value());
  }

  onKeyDown(evt: KeyboardEvent): void {
    if (evt.key === 'Enter' || evt.key === ' ') {
      evt.preventDefault();
      this.controller();
    }
  }
}
